import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Crown, Heart, Zap, X } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const TopicOfTheWeek = () => {
  const [data, setData] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const seen = localStorage.getItem('vent_totw_seen');
    if (seen) {
      setDismissed(true);
      return;
    }

    const fetchTOTW = async () => {
      try {
        const response = await axios.get(`${API}/topic-of-the-week`);
        if (response.data.has_winner) {
          setData(response.data);
        }
      } catch {
      // TOTW fetch is non-critical
    }
    };
    fetchTOTW();
  }, []);

  const handleDismiss = () => {
    setDismissed(true);
    localStorage.setItem('vent_totw_seen', Date.now().toString());
  };

  if (!data || dismissed) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, scale: 0.9, y: -20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.9, y: -20 }}
        transition={{ type: "spring", stiffness: 200, damping: 20 }}
        className="glass rounded-2xl p-5 mb-6 border border-vent-secondary/20 relative overflow-hidden"
        data-testid="topic-of-the-week"
      >
        {/* Background glow */}
        <div className="absolute top-0 right-0 w-32 h-32 bg-vent-secondary/10 rounded-full blur-3xl" />

        <button
          onClick={handleDismiss}
          className="absolute top-3 right-3 p-1.5 hover:bg-white/10 rounded-lg transition-colors z-10"
          data-testid="totw-dismiss"
        >
          <X className="w-4 h-4 text-zinc-500" />
        </button>

        <div className="flex items-center gap-2 mb-3">
          <motion.div
            animate={{ rotate: [0, 10, -10, 0] }}
            transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
          >
            <Crown className="w-5 h-5 text-vent-secondary" />
          </motion.div>
          <span className="text-vent-secondary text-xs font-heading font-bold tracking-[0.2em] uppercase">
            Topic of the Week
          </span>
        </div>

        <p className="text-white font-semibold text-base leading-relaxed mb-3 pr-8">
          "{data.suggestion}"
        </p>

        <div className="flex items-center gap-4 text-xs text-zinc-500">
          <span className="flex items-center gap-1">
            <Heart className="w-3 h-3" /> {data.hearts}
          </span>
          <span className="flex items-center gap-1">
            <Zap className="w-3 h-3" /> {data.lightnings}
          </span>
          <span className="text-vent-secondary/60">Community's choice</span>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default TopicOfTheWeek;
